export default {
  currentTier: {},
  extraFieldsCurrentTier: {},
  userAffiliations: [],
  organizationAffiliations: []
}